import React, { useContext, useState, useEffect } from "react";

import ShareProfileImg from "../../assets/images/shareProfile.png";
import { Link, useLocation } from "react-router-dom";
import { BsArrowLeft } from "react-icons/bs";
import { axiosInstance } from "../../axiosInstance";
import "./ViewProfile.css";
import placeholderImg from "../../assets/images/placeholder-image1.png";

import translations from "./translation.json";
import { LanguageContext } from "../../Components/LanguageContext";
import { Carousel } from "react-bootstrap";

export function ViewProfile() {
  const { language } = useContext(LanguageContext);
  const location = useLocation();
  const { Details } = location.state || {};
  const [agency, setAgency] = useState([]);
  const images = Details.images || [];
  const profile = Details?.profile;

  async function LoadAgencyName() {
    try {
      const response = await axiosInstance.get("profile");
      const agency_name = response.data.data.agency_name;
      console.log("agency_name", agency_name);
      setAgency(agency_name);
    } catch (error) {
      console.error("Error fetching user details", error);
    }
  }

  useEffect(() => {
    LoadAgencyName();
  }, []);
  return (
    <div className="viewmoreBg shareProfile-container">
      <div className="container">
        <div className="agency-name">
          {" "}
          <Link
            to="/view-more"
            style={{ color: "#2B171B", marginRight: "10px" }}
          >
            {" "}
            <span>
              <BsArrowLeft />
            </span>
          </Link>
          {/* {agency ? agency : "Nathicharami Agency"} */}
           <span>{(agency==="null" || agency ===null || agency==="")?"Nathicharami-Agency":agency}</span>
        </div>
        <div className="share-title">{translations[language].biodata}</div>
        <div className="view-container">
          {/* <div className="viewImg">
         
          <a href={Details.profile[0] ? Details.profile[0] : placeholderImg} target="_blank" rel="noopener noreferrer">
  <img src={Details.profile[0] ? Details.profile[0] : placeholderImg} alt="profileImg" />
</a>

        </div> */}
          <div className="viewImg">
            {images.length > 0 ? (
              <Carousel className="profileCarousel">
                {images.map((img, index) => (
                  <Carousel.Item key={index}>
                    <a
                      href={img.image}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        className="d-block w-100"
                        src={img.image}
                        alt={`Slide ${index + 1}`}
                        style={{ maxHeight: "400px", objectFit: "contain" }}
                      />
                    </a>
                  </Carousel.Item>
                ))}
              </Carousel>
            ) : (
              <div className="altprofileviewImg">
                <img src={profile} alt="No profile available" />
              </div>
            )}
          </div>
          <div className="shareProfile-name">{Details.name}</div>
          <div className="view-subcontainer">
            <div className="view-subcontainer-left">
              <div className="shareprofile-subtitle">
                {translations[language].personal_details} :
              </div>
              <div className="profile-detailsContainer">
                <div>{translations[language].gender}</div>
                <div>:</div>
                <div>{Details.gender}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>{translations[language].dob}</div>
                <div>:</div>
                <div>{Details.dob}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>{translations[language].age}</div>
                <div>:</div>
                <div>{Details.age}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>{translations[language].tob}</div>
                <div>:</div>
                <div>{Details.tob}</div>
              </div>
              <div className="profile-detailsContainer">
                <div> {translations[language].pob}</div>
                <div>:</div>
                <div>{Details.pob}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>{translations[language].rashi}</div>
                <div>:</div>
                <div>{Details.rashi}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>{translations[language].nakshatra}</div>
                <div>:</div>
                <div>{Details.nakshatra}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>{translations[language].height}</div>
                <div>:</div>
                <div>{Details.height}</div>
              </div>
              <div className="profile-detailsContainer">
                <div> {translations[language].marital_status}</div>
                <div>:</div>
                <div>{Details.marital_status}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>{translations[language].religion}</div>
                <div>:</div>
                <div>{Details.religion}</div>
              </div>
              <div className="profile-detailsContainer">
                <div> {translations[language].mother_tougue}</div>
                <div>:</div>
                <div>{Details.mother_tongue}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>{translations[language].caste}</div>
                <div>:</div>
                <div>{Details.caste}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>{translations[language].subcaste}</div>
                <div>:</div>
                <div>{Details.sub_caste}</div>
              </div>
              <div className="profile-detailsContainer">
                <div> {translations[language].gothram}</div>
                <div>:</div>
                <div>{Details.gotra}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>{translations[language].manglik}</div>
                <div>:</div>
                <div>{Details.manglik}</div>
              </div>
              <div className="profile-detailsContainer">
                <div> {translations[language].education}</div>
                <div>:</div>
                <div>{Details.education}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>{translations[language].college_name}</div>
                <div>:</div>
                <div>{Details.college_name}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>{translations[language].employed_in}</div>
                <div>:</div>
                <div>{Details.employed_in}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>{translations[language].organization_name}</div>
                <div>:</div>
                <div>{Details.organization_name}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>{translations[language].annual_income}</div>
                <div>:</div>
                <div>{Details.annual_income}</div>
              </div>
            </div>
            <div className="view-subcontainer-right">
              <div className="shareprofile-subtitle">
                {translations[language].family_details}:
              </div>
              <div className="profile-detailsContainer">
                <div>{translations[language].father_name}</div>
                <div>:</div>
                <div>{Details.father_name}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>{translations[language].father_occupation}</div>
                <div>:</div>
                <div>{Details.father_occupation}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>{translations[language].mother_name}</div>
                <div>:</div>
                <div>{Details.mother_name}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>{translations[language].mother_occupation}</div>
                <div>:</div>
                <div>{Details.mother_occupation}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>{translations[language].no_of_brothers}</div>
                <div>:</div>
                <div>{Details.total_brothers}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>{translations[language].no_of_sisters}</div>
                <div>:</div>
                <div>{Details.total_sisters}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>{translations[language].married_brothers}</div>
                <div>:</div>
                <div>{Details.married_brothers}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>{translations[language].married_sisters}</div>
                <div>:</div>
                <div>{Details.married_sisters}</div>
              </div>

              <div className="shareprofile-subtitle">
                {translations[language].contact_details} :
              </div>
              <div className="profile-detailsContainer">
                <div> {translations[language].contact_number}</div>
                <div>:</div>
                <div>{Details.contact_number}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>{translations[language].state}</div>
                <div>:</div>
                <div>{Details.state}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>{translations[language].city}</div>
                <div>:</div>
                <div>{Details.city}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>{translations[language].address}</div>
                <div>:</div>
                <div>{Details.address}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
